import axios from 'axios';
import AutenticarService from "./AutenticarService";

import { getAppUrlApi } from '../helper/Url';

class RequisicaoService {
    constructor(urlBase) {
        this.urlBase = urlBase !== undefined ? urlBase  : '';
    }

    static headers(config) {
        if(config === undefined) {
            config = {headers: {}};
        }

        if(config.headers === undefined) {
            config.headers = {};
        }

        config.headers['token'] = AutenticarService.getToken();
        config.headers['CNPJ'] = AutenticarService.getCnpjEmpresa();

        return config;
    }
    
    static async get(url, config) {
        return axios.get(getAppUrlApi() + url, RequisicaoService.headers(config));
    }

    static async post(url, data, config) {
        return axios.post(getAppUrlApi() + url, data, RequisicaoService.headers(config));
    }

    static async delete(url, config) {
        return axios.delete(getAppUrlApi() + url, RequisicaoService.headers(config));
    }

    static async patch(url, data, config) {
        return axios.patch(getAppUrlApi() + url, data, RequisicaoService.headers(config));
    }
}

export default RequisicaoService;